import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "top-menu-vue element-to-hide" }
const _hoisted_3 = { class: "header-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-building" }, null, -1)
const _hoisted_5 = { class: "branch-info" }
const _hoisted_6 = { class: "pharmacy-text" }
const _hoisted_7 = { class: "branch-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down" }, null, -1)
const _hoisted_9 = { style: {"height":"0.2em","margin":"0","background-color":"#eee"} }
const _hoisted_10 = { class: "dialog-content" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "pharmacy" }, "Pharmacy", -1)
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "branch" }, "Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.switchBranchAvail)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "branch-selector-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args)))
            }, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentPharmacyName || 'Loading...'), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentBranchName || 'Loading...'), 1)
              ]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Menubar, {
          model: _ctx.menuItems,
          class: "header-menu"
        }, null, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.progressBar)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"0.2em"}
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDialog) = $event)),
      header: "Select Pharmacy & Branch",
      modal: true,
      style: { width: '450px' },
      closable: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = false)),
          class: "p-button-text"
        }),
        _createVNode(_component_Button, {
          label: "Switch",
          icon: "pi pi-check",
          onClick: _ctx.switchBranch,
          loading: _ctx.isSwitching,
          disabled: !_ctx.selectedBranchId
        }, null, 8, ["onClick", "loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Dropdown, {
              id: "pharmacy",
              modelValue: _ctx.selectedPharmacyId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPharmacyId) = $event)),
              options: _ctx.pharmacies,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select a Pharmacy",
              onChange: _ctx.onPharmacyChange,
              class: "w-full"
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Dropdown, {
              id: "branch",
              modelValue: _ctx.selectedBranchId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedBranchId) = $event)),
              options: _ctx.branches,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select a Branch",
              disabled: !_ctx.selectedPharmacyId || _ctx.branches.length === 0,
              class: "w-full"
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}